// This file is for organization but can quickly be a crutch.
// Ask yourself - should this be in code or in the team config?

export const isTkeesDebugTheme = (): boolean => {
  return (
    window.location.hostname === "tkees.com" &&
    globalThis.Shopify?.theme?.name ===
      "Performance Issues Fixes Dec 16 25 [Retd 010926]"
  );
};

export enum ThemePublishedStatus {
  ACTIVE_PRIMARY_THEME = "active",
  DRAFT = "draft",
  UNKNOWN = "unknown",
}

export const getThemePublishedStatus = (): ThemePublishedStatus => {
  const themeRole = globalThis.Shopify?.theme?.role;

  if (themeRole === "main") {
    return ThemePublishedStatus.ACTIVE_PRIMARY_THEME;
  } else if (themeRole === "unpublished") {
    return ThemePublishedStatus.DRAFT;
  } else {
    return ThemePublishedStatus.UNKNOWN;
  }
};
